import ReactDOM from "react-dom";

if (!(ReactDOM as any).findDOMNode) {
  (ReactDOM as any).findDOMNode = function (instance: any) {
    if (!instance) return null;
    if (instance && instance.nodeType === 1) return instance;
    try {
      if (typeof instance.getEditor === "function") {
        const editor = instance.getEditor();
        return (editor && editor.root) || null;
      }
    } catch {
      // ignore
    }
    return instance?.base || instance?.root || null;
  };
}